import { Button } from 'primereact/button';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { handlePostRequest } from '../services/PostTemplate';
function LogoutModal({ onHideModal }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const handleLogout = async () => {
        const response = await dispatch(handlePostRequest({}, '/api/auth/logout', true));
        console.log('Logout Response', response);
        if (response) {
            localStorage.clear();
            sessionStorage.clear();
            onHideModal();
            navigate('/');
            // window.location.reload();
        }
    };
    return (
        <>
            <p className="logout__heading">
                <span>
                    <i className="pi pi-sign-out mr-3"></i>
                </span>
                Logout
            </p>
            <p className="logout__text mb-4">Are you sure you want to logout</p>
            <div className="flex mt-2 mb-2 justify-content-center">
                <Button label="Cancel" className="logout__cancel" style={{ width: '160px' }} onClick={() => onHideModal()} />
                <Button label="Logout" className="logout__btn ml-2" style={{ width: '160px' }} onClick={() => handleLogout()} />
            </div>
        </>
    );
}

export default LogoutModal;
